import styled from "@emotion/styled";

export interface GridProps {
    gridTemplateColumns?: string;
    gridTemplateRows?: string;
    gridRowStart?: string;
    gridRowEnd?: string;
    gridColumnStart?: string;
    gridColumnEnd?: string;
    gap?: string;
}

export const Grid = styled.div<GridProps>`
    display: grid;
    grid-column-end: ${({ gridColumnEnd }) => gridColumnEnd};
    /* stylelint-disable-next-line declaration-block-no-redundant-longhand-properties */
    grid-column-start: ${({ gridColumnStart }) => gridColumnStart};
    grid-row-end: ${({ gridRowEnd }) => gridRowEnd};
    /* stylelint-disable-next-line declaration-block-no-redundant-longhand-properties */
    grid-row-start: ${({ gridRowStart }) => gridRowStart};
    grid-template-columns: ${({ gridTemplateColumns }) => gridTemplateColumns};
    grid-template-rows: ${({ gridTemplateRows }) => gridTemplateRows};
    gap: ${({ gap }) => gap};
`;
